import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-translation-page',
  templateUrl: './translation-page.component.html',
  styleUrls: ['./translation-page.component.scss']
})
export class TranslationPageComponent implements OnInit {

  public translateForm: FormGroup;  
  public translateFormSubmitted: boolean = false;

  public subjectMatter: any[] = [
    { id: 'agrarian_sciences', type: 'Ciências Agrárias' },
    { id: 'biological_sciences', type: 'Ciências Biológicas' },    
    { id: 'health_sciences', type: 'Ciências da Saúde' },
    { id: 'exact_and_earth_sciences', type: 'Ciências Exatas e da Terra' },
    { id: 'humanities', type: 'Ciências Humanas' },
    { id: 'applied_social_sciences', type: 'Ciências Sociais Aplicadas' },
    { id: 'engineering', type: 'Engenharias' },
    { id: 'linguistics_letters_and_arts', type: 'Linguísticas, Letras e Artes' },
    { id: 'other', type: 'Outra' },
  ];

  public language: any[] = [
    { id: 'portugues', type: 'Português (Brasil)' },
    { id: 'ingles_american', type: 'Inglês (Americano)' },    
    { id: 'ingles_british', type: 'Inglês (Britânico)' },    
  ];

  constructor(
    private fb: FormBuilder,
  ) {}

  ngOnInit() {
    this.createFontFormGroup();    
  }

  private createFontFormGroup(): void {
    this.translateForm = this.fb.group({
      language_primary: [this.language[0].id, []],
      language_secondary: [this.language[1].id, []],
      quantity_lauda: [0, []],
      subject_matter: [this.subjectMatter[3].id, []],
      delivery_date:[],
    });
  }

  calcPrice () {    
    let inputPrice: any;
    let qtd = this.translateForm.get('quantity_lauda').value;
    inputPrice = document.getElementById('translatePrice');
    
    inputPrice.value = 'R$' + Math.round(qtd * 60).toFixed(2).replace('.',',');
  }

}
